import { Column } from '@viewup/ui';
import { useGetRewardPointMap } from 'app/viewing/_entities/common';
import { PrivateCard } from '../PrivateCard';

export const PrivatePostCampaignList = () => {
  const { data: pointMap } = useGetRewardPointMap();
  const rewardPoint = pointMap?.post.max;

  return (
    <Column css={{ height: 'calc(100% - 32px)', overflow: 'auto' }} gap={16} height={'100%'}>
      {Array(10)
        .fill(0)
        .map((_, i) => (
          // biome-ignore lint/suspicious/noArrayIndexKey: <비로그인상태에 대한 카드 리스트이기 떄문에 인덱스 사용>
          <PrivateCard key={i} point={Number(rewardPoint?.replaceAll(',', ''))} />
        ))}
    </Column>
  );
};
